import React from 'react';
import { ArrowIcon } from './ArrowIcon';
import { Reveal } from './Reveal';
import './Projects.scss';

interface Project {
  title: string;
  image: string;
  tag: string;
  link: string;
}

const projects: Project[] = [
  {
    title: 'Boeing announces the winners of its BUILD 2026 university innovation program',
    image: '/images/build-2026.jpg',
    tag: 'Innovation · Education · Digital Aviation',
    link: 'https://www.boeing-sea.com/news/2026/boeing-announces-winners-of-university-innovation-program',
  },
  {
    title: "Moderating 'Runway to Reality', a panel on AI, automation, and data analytics in aviation",
    image: '/images/panel-discussion.jpg',
    tag: 'AI · Automation · Data Analytics',
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7442759734551834624/',
  },
  {
    title: 'On display in Asia-Pacific for the first time – speaking about Cascade at Singapore Airshow 2024',
    image: '/images/project-11.png',
    tag: 'Sustainability · Digital Aviation',
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7166728905389752320/',
  },
  {
    title: 'From the Hangar to Digital Aviation: our progress and what comes next',
    image: '/images/project-01.jpg',
    tag: 'Innovation · Digital Aviation',
    link: 'https://medium.com/pitchspot/from-the-hangar-to-digital-aviation-57a982f38b70',
  },
  {
    title: 'Organizing the future of hybrid work – pain points and solutions',
    image: '/images/project-02.png',
    tag: 'Future of Work · Productivity · UX Design',
    link: 'https://medium.com/pitchspot/organizing-the-future-of-hybrid-work-195d4ff212ac',
  },
  {
    title: 'Zone – a virtual workspace for productivity and team engagement',
    image: '/images/project-03.png',
    tag: 'Product · UI/UX Design',
    link: 'https://onezone.co/',
  },
  {
    title: 'Ry Weekly – a collection of relevant, accessible, and informative reads',
    image: '/images/project-04.jpg',
    tag: 'Tech Reads · Startups · Finance · Economics',
    link: 'https://t.me/ryweekly',
  },
  {
    title: 'Why innovation is crucial in a crisis – an opinion piece for Capgemini',
    image: '/images/project-06.jpeg',
    tag: 'Sustainability · Innovation · Consulting',
    link: 'https://www.capgemini.com/insights/expert-perspectives/why-innovation-is-crucial-during-a-crisis/',
  },
  {
    title: 'Capgemini co-creates solutions to accelerate the future of recycling in SEA',
    image: '/images/project-05.jpeg',
    tag: 'Sustainability · Venture Creation',
    link: 'https://www.capgemini.com/news/press-releases/capgemini-co-creates-solutions-to-accelerate-the-future-of-recycling-in-southeast-asia-with-heng-hiap-industries/',
  },
  {
    title: 'Pitchspot – an innovation platform to embark on your entrepreneurship journey',
    image: '/images/project-07.jpeg',
    tag: 'UI/UX Design · Entrepreneurship · Innovation',
    link: 'https://pitchspot.co/',
  },
  {
    title: "Trip.ai – optimising travellers' experiences with time-sensitive recommendations",
    image: '/images/project-08.jpg',
    tag: 'UI/UX Design · Artificial Intelligence',
    link: 'https://medium.com/@ryanchongzx/for-all-time-conscious-travellers-alike-6d1d63ffcce2',
  },
  {
    title: 'Sights and scenes taken whilst in Europe, 2016',
    image: '/images/project-09.jpeg',
    tag: 'Photography',
    link: 'https://www.facebook.com/media/set/?set=a.10153490032947266&type=3',
  },
  {
    title: 'A series exploring the different facets of the divine, in a strikingly real way',
    image: '/images/project-10.jpg',
    tag: 'Documentary Photography',
    link: 'https://medium.com/@ryanchongzx/https-medium-com-ryanchongzx-of-documentary-photography-and-god-84e911840e14',
  },
];

const Projects: React.FC = () => {
  return (
    <section id="work" className="work">
      <div className="work__inner section-inner">
        <Reveal className="section-head">
          <h2 className="section-head__label">Selected Work</h2>
          <p className="section-head__statement">
            Ventures, ideas, and stories that shaped the way I think.
          </p>
        </Reveal>

        <div className="work__grid">
          {projects.map((project, idx) => (
            <Reveal key={idx} delay={(idx % 2) * 80}>
              <a
                className="work-card"
                href={project.link}
                target="_blank"
                rel="noopener noreferrer"
                data-cursor-hover
              >
                <div className="work-card__media">
                  <img
                    className="work-card__img"
                    src={project.image}
                    alt=""
                    loading="lazy"
                    onLoad={(e) => e.currentTarget.classList.add('is-loaded')}
                    ref={(el) => {
                      if (el && el.complete) el.classList.add('is-loaded');
                    }}
                  />
                </div>
                <div className="work-card__meta">
                  <h3 className="work-card__title">{project.title}</h3>
                  <ArrowIcon className="work-card__arrow" />
                </div>
                <div className="work-card__tag">{project.tag}</div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
